import { FileModal } from '@/shared/components'
import { convertFileToBase64 } from '@/shared/utils'
import { useState } from 'react'

export const FileViewDialog = ({ file, children }: { file: any; children: React.ReactNode }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [previewData, setPreviewData] = useState<string>('')
  const mimeType = getMimeType(file.originalFileName || file.name)

  const handleView = async () => {
    if (file.base64FileData || file.base64) {
      setPreviewData(file.base64FileData ?? file.base64)
      setModalVisible(true)
    } else if (file instanceof File) {
      try {
        const { base64 } = await convertFileToBase64(file)
        setPreviewData(base64)
        setModalVisible(true)
      } catch (error) {
        console.error('Ошибка конвертации файла:', error)
      }
    }
  }

  return (
    <>
      <button
        onClick={handleView}
        className="p-2 hover:bg-bg-tertiary rounded-lg transition-colors"
        title="Открыть"
      >
        {children}
      </button>
      <FileModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        receiptFile={previewData}
        receiptType={mimeType}
      />
    </>
  )
}
const getMimeType = (fileName: string): string => {
  const extension = fileName.split('.').pop()?.toLowerCase()

  switch (extension) {
    case 'pdf':
      return 'application/pdf'
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'png':
      return 'image/png'
    case 'gif':
      return 'image/gif'
    case 'doc':
      return 'application/msword'
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    case 'xls':
      return 'application/vnd.ms-excel'
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    default:
      return 'application/octet-stream'
  }
}